import { TableColumn } from '@/classes'

const Columns = [
  new TableColumn('Name', 'fullName', true, 'asc', 'left'),
  new TableColumn('Address', 'streetName', true, 'asc', 'left'),
  new TableColumn('Suburb', 'suburb', true, 'asc', 'left'),
  new TableColumn('Phone', 'defaultPhone', true, 'asc', 'left'),
  new TableColumn('Email', 'defaultEmail', true, 'asc', 'left'),
  new TableColumn('Contact', 'defaultContactName', true, 'asc', 'left'),
  new TableColumn('Active', 'active', true, 'asc', 'centered'),
  new TableColumn('', 'action', false, 'desc', 'centered')
]

export default Columns